<!-- 聊天类型组件 -->
<template>
  <div class="ai-chatting">
    <transition :name="isOpenAnimation ? 'van-slide-left' : ''">
      <div v-if="isShow">

        
        <StartChat v-if="cardData.type === 'StartChat'" :cardData="cardData"></StartChat>
        <ChatText
        v-if="cardData.type === 'ChatText'"
        :cardData="cardData"
        :hideInlineConfirm="hideInlineConfirm"
        @sendUserConfirmMsg="sendUserConfirmMsg"
        ></ChatText>
        <ChatConfirm
          v-if="cardData.type === 'ChatConfirm'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
          @sendMsg="sendMsg"
        ></ChatConfirm>
        <ChatAnswerSheet
          v-if="cardData.type === 'ChatAnswerSheet'"
          :cardData="cardData"
          @taskCompleted="taskCompleted"
        ></ChatAnswerSheet>
        <ChatProblem
          v-if="cardData.type === 'ChatProblem'"
          @confirmFn="confirmFn"
          :isCanEdit="isCanEdit"
          :cardData="cardData"
          :nextData="nextData"
        ></ChatProblem>
        <ChatCheckbox
          v-if="cardData.type === 'ChatCheckbox'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatCheckbox>
        <ChatTextarea
          v-if="cardData.type === 'ChatTextarea'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatTextarea>
        <ChatEmotion
          v-if="cardData.type === 'ChatEmotion'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatEmotion>
        <ChatEmotionDetails
          v-if="cardData.type === 'ChatEmotionDetails'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatEmotionDetails>
        <ChatActions
          v-if="cardData.type === 'ChatActions'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatActions>
        <ChatCheckboxActivity
          v-if="cardData.type === 'ChatCheckboxActivity'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatCheckboxActivity>
        <ChatEmotionalRuler
          v-if="cardData.type === 'ChatEmotionalRuler'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
          @sendEmotionalRuler="sendEmotionalRuler"
        ></ChatEmotionalRuler>
        <ChatAutomatedMind
          v-if="cardData.type === 'ChatAutomatedMind'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatAutomatedMind>
        <ChatReconstructionCard
          v-if="cardData.type === 'ChatReconstructionCard'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatReconstructionCard>
        <ChatTwelveProblemsAst
          v-if="cardData.type === 'ChatTwelveProblemsAst'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatTwelveProblemsAst>
        <ChatEmotionReadOnly
          v-if="cardData.type === 'ChatEmotionReadOnly'"
          :cardData="cardData"
        ></ChatEmotionReadOnly>
        <ChatAutomatedMindSelect
          v-if="cardData.type === 'ChatAutomatedMindSelect'"
          :cardData="cardData"
          @confirmFn="confirmFn"
        ></ChatAutomatedMindSelect>
        <ChatStrategyCard
          v-if="cardData.type === 'ChatStrategyCard'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatStrategyCard>
        <ChatProgressCard
          v-if="cardData.type === 'ChatProgressCard'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          :nextData="nextData"
          @confirmFn="confirmFn"
        ></ChatProgressCard>
        <ChatConfirmMore
          v-if="cardData.type === 'ChatConfirmMore'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          @sendMsgMore="sendMsgMore"
          @sendMsg="sendMsg"
        ></ChatConfirmMore>
        <ChatVideo
          v-if="cardData.type === 'ChatVideo'"
          :cardData="cardData"
          :isCanEdit="isCanEdit"
          @sendMsg="sendMsg"
        ></ChatVideo>
      </div>
    </transition>
    <transition :name="isOpenAnimation ? 'van-slide-right' : ''">
      <div v-if="isShow">
        <ChatSend v-if="cardData.type === 'ChatSend'" :cardData="cardData"></ChatSend>
      </div>
    </transition>
  </div>
</template>

<script>
import StartChat from "./ChatCard/StartChat.vue";
import ChatText from "./ChatCard/ChatText.vue";
import ChatConfirm from "./ChatCard/ChatConfirm.vue";
import ChatSend from "./ChatCard/ChatSend.vue";
import ChatAnswerSheet from "./ChatCard/ChatAnswerSheet.vue";
import ChatProblem from "./ChatCard/ChatProblem.vue";
import ChatCheckbox from "./ChatCard/ChatCheckbox.vue";
import ChatTextarea from "./ChatCard/ChatTextarea.vue";
import ChatEmotion from "./ChatCard/ChatEmotion.vue";
import ChatEmotionDetails from "./ChatCard/ChatEmotionDetails.vue";
import ChatActions from "./ChatCard/ChatActions.vue";
import ChatCheckboxActivity from "./ChatCard/ChatCheckboxActivity.vue";
import ChatEmotionalRuler from "./ChatCard/ChatEmotionalRuler.vue";
import ChatAutomatedMind from "./ChatCard/ChatAutomatedMind.vue";
import ChatReconstructionCard from "./ChatCard/ChatReconstructionCard.vue";
import ChatTwelveProblemsAst from "./ChatCard/ChatTwelveProblemsAst.vue";
import ChatEmotionReadOnly from "./ChatCard/ChatEmotionReadOnly.vue";
import ChatAutomatedMindSelect from "./ChatCard/ChatAutomatedMindSelect.vue";
import ChatStrategyCard from "./ChatCard/ChatStrategyCard.vue";
import ChatProgressCard from "./ChatCard/ChatProgressCard.vue";
import ChatConfirmMore from "./ChatCard/ChatConfirmMore.vue";
import ChatVideo from "./ChatCard/ChatVideo.vue";

export default {
  name: "AIChatting",
  components: {
    StartChat,
    ChatText,
    ChatConfirm,
    ChatSend,
    ChatAnswerSheet,
    ChatProblem,
    ChatCheckbox,
    ChatTextarea,
    ChatEmotion,
    ChatEmotionDetails,
    ChatActions,
    ChatCheckboxActivity,
    ChatEmotionalRuler,
    ChatAutomatedMind,
    ChatReconstructionCard,
    ChatTwelveProblemsAst,
    ChatEmotionReadOnly,
    ChatAutomatedMindSelect,
    ChatStrategyCard,
    ChatProgressCard,
    ChatConfirmMore,
    ChatVideo,
  },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 下一条数据
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    isOpenAnimation: {
      type: Boolean,
      default: true,
    },
    hideInlineConfirm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.isShow = true;
    }, 100);
  },
  methods: {
    // 提交
    confirmFn(data) {
      this.$emit("confirmFn", data);
    },
    // 发送消息
    sendMsg(data) {
      this.$emit("sendMsgFn", data);
    },

    sendMsgMore(data) {
      this.$emit("sendMsgFn", data);
    },

    // 发送情绪尺子
    sendEmotionalRuler() {
      this.$emit("sendEmotionalRuler");
    },
    // 交互式对话，确认下一步
    sendUserConfirmMsg(data) {
      console.log("in AI Chatting")
      this.$emit("sendUserConfirmMsg", data);
    },
    taskCompleted(data) {
      this.$emit("taskCompleted", data);
    }
  }
};
</script>

<style scoped lang="scss">
.ai-chatting {
  width: 100%;
  margin-bottom: 14px;
}
</style>
